// Because of how vite works and how jQuery works, importing jQuery and
// exposing these globals on the window object must be done here.
import jquery from 'jquery'

window.$ = jquery
window.jQuery = jquery
